import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import { unwrapProcurement } from '../utils/tenderOpeningHelpers';

const useProcurementDetail = procurementId => {
  const [procurement, setProcurement] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProcurement = useCallback(async () => {
    if (!procurementId) return;

    const token = getAuthToken();
    if (!token) {
      toast.error('Authentication required. Please login again.');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `${api.API_URL}/procurement/${procurementId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        }
      );
      setProcurement(unwrapProcurement(response));
    } catch (err) {
      const message =
        typeof err === 'string' ? err : 'Failed to load procurement detail';
      setError(message);
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  }, [procurementId]);

  useEffect(() => {
    fetchProcurement();
  }, [fetchProcurement]);

  return {
    procurement,
    isLoading,
    error,
    refresh: fetchProcurement,
  };
};

export default useProcurementDetail;
